const ZoomOutIcon = () => {
    return (
        <img
            style={{ width: '100%', height: '100%' }}
            src="/images/zoom-out-icon.svg"
            alt="Document Icon"
        />
    );
};

export default ZoomOutIcon;
